import { UserResources } from "~/components/organisms/user/UserResources";

export const ResourcesTab = () => {
  return (
    <div className="mb-8 duration-700 animate-in fade-in sm:w-56">
      <UserResources showLines />
    </div>
  );
};
